import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import './DetailsPanel.scss';

export function DetailsPanel(
    props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
) {
    return (
        <div
            {...props}
            className={`DetailsPanel details-panel ${props.className}`}
        />
    );
}
